import { fromJS } from 'immutable';
import {
	SET_CUSTOMER_ACCOUNT_DATA,
	CLEAR_CUSTOMER_ACCOUNT_DATA,
} from './actionsCustomerAccount';

const initialState = fromJS({
	accountId: '',
});

// eslint-disable-next-line default-param-last
const customerAccountReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_CUSTOMER_ACCOUNT_DATA:
			return state.merge({
				accountId: action.payload.accountId,
			});
		case CLEAR_CUSTOMER_ACCOUNT_DATA:
			return initialState;
		default:
			return state;
	}
};

export default customerAccountReducer;
